import React from "react";
import { useTermsStyles } from "./Terms.styles";

export const TermsEn: React.FC = () => {
  const classes = useTermsStyles();

  return (
    <div className={classes.root}>
      {/* Main Header */}
      <h1 className={classes.mainHeader}>Terms and Conditions of Use</h1>
      <div className={classes.subMainHeader}>
        Last Updated: December 12, 2024.
      </div>

      {/* ======================== TERMS & CONDITIONS OF USE ======================== */}
      <section className={classes.section}>
        <p className={classes.content}>
          Welcome to the Sharon Farms website (the <b>"Site"</b>). This Site
          serves as an online store for purchasing various products by the
          Israeli public via the Internet. Please review these Terms before
          using the Site.
        </p>

        <ol className={classes.list}>
          <li>
            The operator of the Site and the services offered herein, and the
            owner of the Site, is Grasslands Ltd., registration number
            517003703, located at 44 Miriam HaHashmonait Street,
            Modi'in-Maccabim-Re'ut (hereafter referred to as{" "}
            <b>"Site Operator"</b> or
            <b>"Owner</b>).
          </li>

          <li>Sharon Farms’ address is _____________________.</li>

          <li>
            Products on the Site are offered by various suppliers. Selected
            products are delivered directly from each supplier.
          </li>

          <li>
            These Terms apply to every use by any user and/or person making
            transactions on the Site <b>("Customer")</b> and to every order made
            by the Customer through the Site. Therefore, the Customer is
            requested to thoroughly read these Terms and agree to comply with
            them.
          </li>

          <li>
            Any action on the Site, including the purchase of products offered
            for sale on the Site, constitutes the Customer's acceptance of these
            Terms and agreement to abide by them.
          </li>

          <li>
            These Terms are written in masculine gender for convenience purposes
            only but apply equally to both genders. Terms are expressed in
            singular form for convenience but apply also to plural forms.
          </li>

          <li>
            The Customer declares that he has read these Terms and agrees with
            them. It is emphasized that any activity on the Site constitutes an
            absolute, final, and irrevocable declaration by the Customer that he
            has read, understood, and agreed to these Terms.
          </li>

          <li>
            The Site Operator reserves the right to deny access to the Site
            and/or prevent any activity on it to anyone violating the Terms or
            misusing the Site or its contents.
          </li>

          <li>
            The Site Operator and/or the Company reserve the right to update
            and/or change the contents of the Site, the products and services
            offered, and these Terms without prior notice. Such changes shall
            apply to all entries to the Site or orders made from the moment of
            change. The Customer will have no claim and/or lawsuit against the
            Site Operator and/or the Company due to such changes.
          </li>

          <li>
            It is clarified, for the avoidance of doubt, that there may be
            differences between using the Site via a tablet and/or mobile device
            or application and using the Site via desktop and/or laptop
            computers.
          </li>

          <li>
            For further inquiries, please contact the Site Operator's customer
            service via email at{" "}
            <a href="mailto:customerservice@emailexample.com">
              customerservice@emailexample.com
            </a>
            .
          </li>
        </ol>
      </section>

      {/* ======================== ORDERS ON THE SITE ======================== */}
      <section className={classes.section}>
        <h2 className={classes.title}>Orders on the Site</h2>

        <ol className={classes.list}>
          <li>
            The Company and Site Operator allow Customers to conveniently and
            quickly purchase products of manufacturers, importers, and retailers
            operating in Israel through the Site. The Site serves as a platform
            for presenting products offered by various suppliers and is not the
            manufacturer, importer, or retailer of the displayed products.
          </li>

          <li>
            Orders and payments for products are made via the Site Operator and
            are delivered from each supplier separately. Responsibility
            regarding products lies solely with the supplier.
          </li>

          <li>
            Products sold on the Site are intended exclusively for private and
            personal use and are not meant for wholesale.
          </li>

          <li>
            If an error occurs in describing the product and/or service, payment
            terms, or product images, the Company may cancel the specific order
            before delivery to the Customer.
          </li>

          <li>
            Before placing an order on the Site, the Customer must register. The
            Customer undertakes to provide accurate, complete, and updated
            information.
          </li>

          <li>
            Payment on the Site is made by credit cards accepted in Israel as
            detailed on the Site. Purchases using checks, vouchers, gift cards,
            prepaid cards, coupons, or credits are not permitted unless
            otherwise indicated.
          </li>

          <li>
            The Customer will receive confirmation of the transaction only after
            payment approval by the credit card company. If the transaction is
            not approved, the Customer will receive a notification of
            transaction cancellation and will have no claim and/or demand
            against the Site Operator, the supplier, or the Company. If the
            transaction is approved, the order will be recorded, and a
            confirmation email will be sent to the Customer. Only an email
            confirmation containing the relevant order details, including the
            order number, customer information, and order details, constitutes
            acceptance by the Site Operator.
          </li>

          <li>
            The Site Operator’s records of actions performed via the Site serve
            as prima facie evidence of their correctness.
          </li>

          <li>
            Payment for all products in the same order is made directly to the
            Site Operator, and the invoice is issued by the Site Operator upon
            product delivery. The name of the Site Operator's business will
            appear on the credit card transaction details.
          </li>

          <li>
            Delivery charges apply according to the Site's shipping and delivery
            policy.
          </li>

          <li>
            Delivery times are detailed in the shipping and delivery policy on
            the Site. As products are supplied by each supplier separately,
            deliveries for multiple items may occur separately.
          </li>

          <li>
            Product prices are displayed alongside products, with shipping costs
            presented during the purchase process. Before initiating the
            purchase, Customers are requested to fill in personal details and a
            shipping address. Shipping prices may vary based on the delivery
            area and will be displayed during the ordering process.
          </li>

          <li>
            All inquiries regarding products, deliveries, payments, or
            transaction cancellations should be directed to the Site Operator,
            who will forward them to the relevant party. The Site Operator
            and/or the Company hold no responsibility for the products
            themselves under any circumstances.
          </li>
        </ol>
      </section>

      {/* ======================== ORDER CANCELLATION ======================== */}
      <section className={classes.section}>
        <h2 className={classes.title}>Order Cancellation</h2>

        <ol className={classes.list}>
          <li>
            According to the Consumer Protection Law, 1981, Customers have the
            right to cancel product purchase transactions made via the Site
            under the law's terms and conditions.
          </li>

          <li>
            The transaction may be canceled from the date it was made until 14
            days after receipt of the product or the transaction details
            document, whichever comes later.
          </li>

          <li>
            Transactions with disabled persons, senior citizens, or new
            immigrants may be canceled within four months from the transaction
            date, product receipt, or receipt of transaction details, whichever
            is later, provided the transaction involved a conversation with the
            consumer. Appropriate certification may be requested.
          </li>

          <li>
            Transactions can be canceled by telephone, registered mail, email,
            or via the "Cancel Transaction" link on the Site. The Site Operator
            may request identifying details to verify the transaction.
          </li>

          <li>
            The Site Operator will charge a cancellation fee up to 5% of the
            transaction value or NIS 100, whichever is lower.
          </li>

          <li>
            The Site Operator reserves the right to claim damages if the product
            value significantly depreciates due to deterioration.
          </li>

          <li>
            If products were delivered before cancellation notification, the
            Customer must return them to Sharon Farms according to Consumer
            Protection Law. The Site Operator will assist with the return
            process or offer a paid home pick-up service.
          </li>

          <li>
            Cancellation due to defective products will result in the product
            return at the Site Operator's expense, cancellation of the
            transaction, and a refund.
          </li>

          <li>
            Cancellation rights are invalid for products specifically made for
            the Customer or perishable items.
          </li>
        </ol>
      </section>

      {/* ======================== INTELLECTUAL PROPERTY ======================== */}
      <section className={classes.section}>
        <h2 className={classes.title}>Intellectual Property</h2>

        <p className={classes.content}>
          All content on the Site is the exclusive property of the Site Operator
          and/or Company or third parties granting rights or licenses to the
          Operator. Any unauthorized copying, distribution, or exploitation of
          Site content without written consent is strictly prohibited.
        </p>
      </section>
    </div>
  );
};
